var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-footer-bar",style:({
    width: _vm.isSideMenu()
      ? ("calc(100% - " + (_vm.sidebarOpened ? 256 : 80) + "px)")
      : '100%'
  })},[_c('div',{staticStyle:{"float":"left"}},[_vm._t("extra",[_vm._v(_vm._s(_vm.extra))])],2),_c('div',{staticStyle:{"float":"right"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }